import { Container } from '@app/engine/core/container';
import { Singletons } from '@app/engine/core/interfaces';
export class ServiceLocator {
    static getSoundManager = () => Container.getInstance().get(Singletons.SoundManager);
    static getRenderer = () => Container.getInstance().get(Singletons.WebGLRenderer);
    static getScene = () => Container.getInstance().get(Singletons.Scene);
    static getCatalogManager = () => Container.getInstance().get(Singletons.CatalogManager);
    static getSensorManager = () => Container.getInstance().get(Singletons.SensorManager);
    static getUiManager = () => Container.getInstance().get(Singletons.UiManager);
    static getInputManager = () => Container.getInstance().get(Singletons.InputManager);
    static getGroupsManager = () => Container.getInstance().get(Singletons.GroupsManager);
    static getTimeManager = () => Container.getInstance().get(Singletons.TimeManager);
    static getOrbitManager = () => Container.getInstance().get(Singletons.OrbitManager);
    static getColorSchemeManager = () => Container.getInstance().get(Singletons.ColorSchemeManager);
    static getDotsManager = () => Container.getInstance().get(Singletons.DotsManager);
    static getSensorMath = () => Container.getInstance().get(Singletons.SensorMath);
    static getLineManager = () => Container.getInstance().get(Singletons.LineManager);
    static getHoverManager = () => Container.getInstance().get(Singletons.HoverManager);
    static getMainCamera = () => Container.getInstance().get(Singletons.MainCamera);
    static getMeshManager = () => Container.getInstance().get(Singletons.MeshManager);
}
